export default class ApiError extends Error {
  body
  status
  response
  hasToRetry = false
  isUnknownError = false
  shouldInvalidateForm = true
  children = {}

  constructor(getApiErrorMessage, getApiFallbackErrorMessage, error) {
    const message = getApiErrorMessage(error)
    const fallBackMessage = getApiFallbackErrorMessage(error)
    super(message ?? fallBackMessage)
    this.body = error.body
    this.status = error.status
    this.response = error.response
    this.isUnknownError = message === undefined
    this.children = this.getChildren()
  }

  getChildren() {
    return {}
  }
}
